import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import DontLeave from "app/pages/.shared/DontLeave";
import Page from "app/pages/.shared/Page/Page";
import HeadMetadata from "app/utils/metas/HeadMetadata";
import { sendTagOnPageNotFound } from "app/utils/analytics";
import { getFallbackRedirectUrl, getSeoMetaData } from "app/reducers/partnerSelector";
import { useSelector, shallowEqual } from "react-redux";
import "./NotFound.scss";
import Button, { BUTTON_SIZES, BUTTON_VARIANTS } from "app/pages/.shared/form/Button";

const mapStateToProps = state => {
	return {
		fallbackRedirectUrl: getFallbackRedirectUrl(state),
		titleFromSanity: getSeoMetaData("notFound.metaTitle")(state),
		descriptionFromSanity: getSeoMetaData("notFound.metaDescription")(state),
	};
};

const NotFound = () => {
	const { fallbackRedirectUrl, titleFromSanity, descriptionFromSanity } = useSelector(
		mapStateToProps,
		shallowEqual
	);

	useEffect(() => {
		sendTagOnPageNotFound();
	}, []);

	const title = titleFromSanity || "page.title.404";
	const description = descriptionFromSanity || "page.description.404";

	return (
		<div className="not-found">
			<Page title={<FormattedMessage id="not.found.title" />}>
				<HeadMetadata description={description} title={title} />
				<div className="not-found__intro">
					<FormattedMessage id="not.found.message" />
					<DontLeave>
						<Button
							to={{ pathname: fallbackRedirectUrl }}
							variant={BUTTON_VARIANTS.FILLED}
							size={BUTTON_SIZES.LARGE}
							label={<FormattedMessage id="confirmation.leave.button.label" />}
							data-testid="confirm-leave-link"
						/>
					</DontLeave>
				</div>
			</Page>
		</div>
	);
};

export default NotFound;
